import {Layout} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import {useResponsive} from '@/contexts/ResponsiveContext';

const PageContentContext = createContext();

function PageContent({children, disableBreadcrumbFor = [], disableBreadcrumb, className, ...rest}) {
  const [title, setTitle] = useState();
  const {isMobile} = useResponsive();
  const {pathname} = useLocation();
  const [breadcrumbCustomMap, setBreadcrumbCustomMap] = useState({});

  // eslint-disable-next-line no-unused-vars
  const isDisableBread = useMemo(() => {
    return disableBreadcrumbFor.includes(pathname);
  }, [disableBreadcrumbFor, pathname]);

  const addCustomBreadcrumbMap = useCallback((mapDict) => {
    setBreadcrumbCustomMap({...breadcrumbCustomMap, ...mapDict});
  }, [breadcrumbCustomMap]);

  return (
    <PageContentContext.Provider value={{
      setBreadcrumbCustomMap,
      addCustomBreadcrumbMap,
      setTitle
    }}>
      <Layout>
        <Layout.Content className={classNames('m-1 lg:my-1 lg:mx-5', className)}>
          {!isDisableBread && !disableBreadcrumb &&
            <PageHeader title={title} className={classNames({'truncate': isMobile})}
              customMap={breadcrumbCustomMap} ghost {...rest}/>}
          {children}
        </Layout.Content>
      </Layout>
    </PageContentContext.Provider>
  );
}

function usePageContent(options = {}) {
  const context = useContext(PageContentContext);
  if (context === undefined) {
    throw new Error('usePageContent must be used within a PageContentProvider');
  }
  const {title} = options;
  const {
    setTitle, setBreadcrumbCustomMap, addCustomBreadcrumbMap
  } = context;

  useEffect(() => {
    if (title)
      setTitle(title);
    return () => setTitle('');
  }, [setTitle, title]);

  return {
    setTitle,
    setBreadcrumbCustomMap,
    addCustomBreadcrumbMap
  };
}

PageContent.propTypes = {
  className: PropTypes.string,
  disableBreadcrumbFor: PropTypes.array,
  disableBreadcrumb: PropTypes.bool,
  children: PropTypes.any
};

export {PageContent, usePageContent};
